import { useAreaCrumbs } from "@/components/areaCrumbs";
import type { Crumb } from "@/components/PageBreadcrumbs";
import { useSpaceInSidebar } from "@/features/shell/useSidebarSpaces";

/** The crumb a space's own pages start from: `{Space}` (docs/design/web/WEB_BREADCRUMBS_DESIGN.md, short form). */
export function spaceCrumb(spaceUuid: string, name: string | undefined): Crumb {
  return { label: name ?? "", to: `/spaces/${spaceUuid}` };
}

/** `Spaces / {Space}` for a space's page when the sidebar doesn't list the space; otherwise no trail. */
export function useSpaceTrail(spaceUuid: string | undefined, name: string | undefined): Crumb[] | undefined {
  const areas = useAreaCrumbs();
  const inSidebar = useSpaceInSidebar(spaceUuid ?? "");
  return spaceUuid && inSidebar === false ? [areas.spaces, spaceCrumb(spaceUuid, name)] : undefined;
}
